import * as React from 'react'

import { Box, useToggle } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { Filter } from '@factorialco/f0-react/icons/app'

import FilterPanel from 'modules/core/components/MultiFilters/FilterPanel'
import type LogicOperatorForm from 'modules/core/components/MultiFilters/Forms/LogicOperatorForm'
import type MultiFilterForm from 'modules/core/components/MultiFilters/Forms/MultiFilterForm'
import type { FilterOption as MultiFilterOption } from 'modules/core/components/MultiFilters/types'
import Popover from 'modules/core/components/Popover'
import i18n from 'modules/core/lib/i18n'

interface Props {
  fields: readonly MultiFilterOption[]
  filters: MultiFilterForm[]
  logicOperator: LogicOperatorForm
  onAddFilter: () => void
  onRemoveFilter: (index: number) => void
  onApplyFilters: () => void
  onCancel: () => void
  buttonText?: string
}

const FilterPopover = ({
  fields,
  filters,
  logicOperator,
  onAddFilter,
  onRemoveFilter,
  onApplyFilters,
  onCancel,
}: Props) => {
  const [isOpen, toggleOpen] = useToggle(false)

  const handleCancel = () => {
    onCancel()
    toggleOpen(false)()
  }

  const handleApplyFilters = () => {
    onApplyFilters()
    toggleOpen(false)()
  }

  return (
    <Box
      flexDirection="row"
      maxWidth="s120"
      minHeight="s40"
      overflowX="hidden"
      position="relative"
      alignItems="center"
    >
      <Popover
        attachment="top left"
        targetAttachment="bottom center"
        open={isOpen}
        toggle={toggleOpen}
        size="auto"
      >
        <F0Button
          hideLabel
          variant="outline"
          icon={Filter}
          onClick={toggleOpen(true)}
          label={i18n.t('common.filter')}
        />
        <FilterPanel
          emptyStateLabel={i18n.t('filters.multi_filters.empty_state')}
          fields={fields}
          filters={filters}
          logicOperator={logicOperator}
          onAddFilter={onAddFilter}
          onRemoveFilter={onRemoveFilter}
          onApplyFilters={handleApplyFilters}
          onCancel={handleCancel}
        />
      </Popover>
    </Box>
  )
}

export default FilterPopover
